import { render, staticRenderFns } from "./agriServiceDetail.vue?vue&type=template&id=257bf3e7&scoped=true"
import script from "./agriServiceDetail.vue?vue&type=script&lang=js"
export * from "./agriServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./agriServiceDetail.vue?vue&type=style&index=0&id=257bf3e7&prod&lang=less&scoped=true"
import style1 from "./agriServiceDetail.vue?vue&type=style&index=1&id=257bf3e7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257bf3e7",
  null
  
)

export default component.exports